var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"left"},[_c('router-link',{attrs:{"to":"/projects"}},[_c('img',{attrs:{"src":require("@/assets/logowhite.svg")}})])],1),_c('div',{staticClass:"right"},[(_vm.user)?_c('router-link',{staticClass:"user",attrs:{"to":"/profile"}},[_c('img',{attrs:{"src":_vm.gravatar}})]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }